import Vue from 'vue'
import VueRouter from 'vue-router'

import Signup from '../views/Signup.vue'
import Verification from "@/views/Verification.vue";
import Redirect from "@/views/Redirect.vue";  // Corrected typo

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Initial',
    component: Redirect,
    beforeEnter: (to, from, next) => {
      // Redirect to a default page if no ID is found
      next('/redirect');
    }
  },
  {
    path: '/redirect',  // Default page if there's no ID
    name: 'Redirect',
    component: Redirect
  },
  {
    path: '/verification/:id',  // Verification route with ID
    name: 'Verification',
    component: Verification
  },
  {
    path: '/signup/:id',  // Signup route with ID
    name: 'Signup',
    component: Signup
  },
  {
    path: '/home/:id',  // Home route with ID
    name: 'home',
    component: function () {
      return import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
    }
  },
  {
    path: '/about/:id',  // About route with ID
    name: 'about',
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '',
  routes
})

export default router
